import {ExternalLinksHandlersFactory} from "../../external-links-handlers-factory";
import {
    IMyAccountUploadDocumentsExternalLinkHandler
} from "../../../handlers/my-account-upload-documents/my-account-upload-documents.external-link-handler.interface";
import {
    ItalyMyAccountUploadDocumentsExternalLinkHandler
} from "../../../handlers/my-account-upload-documents/regulations/italy/italy.my-account-upload-documents.external-link-handler";

export class ItalyExternalLinksHandlersFactory extends ExternalLinksHandlersFactory {

    get myAccountUploadDocuments(): IMyAccountUploadDocumentsExternalLinkHandler {
        return new ItalyMyAccountUploadDocumentsExternalLinkHandler(this.services)
    }
}